import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { getWhatsAppLink } from '../../utils/whatsapp';
const plans = [{
  key: 'core',
  name: 'CORE',
  desc: 'Para empresas que necesitan atención telefónica automatizada.',
  setup: '$2.500.000',
  monthly: '$1.500.000/mes',
  featured: false,
  capabilities: ['Llamadas entrantes', 'Identificación y comprensión', 'Captura y calificación', 'CRM + agenda', 'Transferencia humana'],
  whatsapp: 'Hola ORIGEN, quiero VOICE CORE.'
}, {
  key: 'growth',
  name: 'GROWTH',
  badge: 'MÁS ELEGIDO',
  desc: 'Para empresas que quieren convertir el teléfono en un canal comercial.',
  setup: '$4.000.000',
  monthly: '$2.800.000/mes',
  featured: true,
  capabilities: ['Todo CORE', 'Llamadas salientes', 'Confirmaciones y reactivación', 'CRM avanzado + WhatsApp', 'Dashboard de seguimiento'],
  whatsapp: 'Hola ORIGEN, quiero VOICE GROWTH.'
}, {
  key: 'scale',
  name: 'SCALE',
  desc: 'Para operaciones de mayor volumen y complejidad.',
  setup: '$6.000.000',
  monthly: '$4.800.000/mes',
  featured: false,
  capabilities: ['Todo GROWTH', 'Múltiples agentes y líneas', 'Integraciones vía API', 'Campañas de alto volumen', 'Soporte prioritario'],
  whatsapp: 'Hola ORIGEN, quiero VOICE SCALE.'
}];
export function VoicePlans() {
  return <section className="bg-arena py-[44px] md:py-[64px]" data-id="element-307" data-mp="200mrqnlu7mt9">
      <div className="max-w-[1200px] mx-auto px-6 md:px-20" data-id="element-308" data-mp="1zz3aouscx7qf">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="text-center max-w-[520px] mx-auto mb-10" data-id="element-309" data-mp="24t7fb7e5h3oc">
          <span className="block font-body text-[11px] uppercase font-medium text-salvia tracking-[0.15em] mb-3" data-id="element-310" data-mp="2isp9k2a7t953">
            PLANES VOICE
          </span>
          <h3 className="font-display text-[24px] md:text-[30px] font-bold text-carbon" data-id="element-311" data-mp="in1tavbhwd9f">
            Tres niveles de agente de voz.
          </h3>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch" data-id="element-312" data-mp="sgsftuo2admh">
          {plans.map((plan, idx) => <motion.div key={plan.key} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.35,
          ease: 'easeOut',
          delay: idx * 0.08
        }} className={`relative flex flex-col rounded-[12px] p-6 md:p-7 transition-all duration-200 ${plan.featured ? 'bg-carbon text-arena md:-translate-y-2 shadow-cta border border-carbon' : 'bg-arena-dark text-carbon border border-carbon/10 hover:border-verde/40 hover:-translate-y-[2px] hover:shadow-card'}`} data-id="element-313" data-mp="nmehpki0lse4" data-mpi={idx}>
              {plan.badge && <span className="absolute -top-3 left-1/2 -translate-x-1/2 font-body text-[10px] font-semibold uppercase tracking-[0.1em] px-3 py-1 rounded-full bg-azul text-arena whitespace-nowrap" data-id="element-314" data-mp="1smw9oktdxbp0">
                  {plan.badge}
                </span>}
              <h4 className={`font-display text-[17px] font-bold mb-2 ${plan.featured ? 'text-arena' : 'text-carbon'}`} data-id="element-315" data-mp="14xk03ju5b1m6">
                VOICE {plan.name}
              </h4>
              <p className={`font-body text-[12.5px] leading-[1.6] mb-5 flex-grow ${plan.featured ? 'text-arena/75' : 'text-carbon/60'}`} data-id="element-316" data-mp="vy6r0s9xof1z">
                {plan.desc}
              </p>
              <div className={`h-px w-full mb-4 ${plan.featured ? 'bg-arena/20' : 'bg-carbon/10'}`} data-id="element-317" data-mp="2qchcqrv8et3j" />
              <div className="mb-5" data-id="element-318" data-mp="2uaf5u5s4hzc7">
                <span className={`font-display text-[18px] font-bold ${plan.featured ? 'text-arena' : 'text-carbon'}`} data-id="element-319" data-mp="25mdimlxzro4e">
                  {plan.setup}
                </span>
                <span className={`font-body text-[11px] ml-1.5 ${plan.featured ? 'text-arena/60' : 'text-carbon/45'}`} data-id="element-320" data-mp="1vmwei8ye1iaj">
                  implementación
                </span>
                <div data-id="element-321" data-mp="1mo192z364c8a">
                  <span className={`font-body text-[13px] font-medium ${plan.featured ? 'text-arena/85' : 'text-carbon/70'}`} data-id="element-322" data-mp="1mokfpjndbe70">
                    {plan.monthly}
                  </span>
                </div>
              </div>
              <ul className="flex flex-col gap-1.5 mb-6" data-id="element-323" data-mp="17zej83fx022t">
                {plan.capabilities.map(cap => <li key={cap} className={`font-body text-[12px] flex items-start gap-1.5 ${plan.featured ? 'text-arena/75' : 'text-carbon/60'}`} data-id="element-324" data-mp="12xyy6bdqlvkf">
                    <span className={`mt-[7px] w-1 h-1 rounded-full flex-shrink-0 ${plan.featured ? 'bg-arena/50' : 'bg-verde/50'}`} data-id="element-325" data-mp="3akh32dxhw2qu" />
                    {cap}
                  </li>)}
              </ul>
              <a href={getWhatsAppLink(plan.whatsapp)} target="_blank" rel="noopener noreferrer" className={`mt-auto inline-flex items-center justify-center font-display font-semibold text-[13.5px] px-5 py-3 rounded-[6px] transition-all duration-200 ${plan.featured ? 'bg-arena text-carbon hover:bg-[#EAE7E0]' : 'bg-verde text-arena hover:bg-verde-hover hover:-translate-y-[1px] hover:shadow-cta'}`} data-id="element-326" data-mp="3olbez6jr4lu9">
                Quiero VOICE {plan.name}{' '}
                <ArrowRight size={14} className="ml-1.5" data-id="element-327" data-mp="2d4uvn252tl24" />
              </a>
            </motion.div>)}
        </div>

        <p className="text-center font-body text-[12.5px] text-carbon/45 max-w-[520px] mx-auto mt-8 leading-[1.6]" data-id="element-328" data-mp="253m4g6wnbp6z">
          Los planes incluyen una capacidad mensual de uso. El consumo
          adicional se cotiza según volumen. No ofrecemos uso ilimitado. Para
          operaciones de mayor escala, cotización personalizada bajo
          ENTERPRISE.
        </p>
      </div>
    </section>;
}